import { ReactNode } from "react";
import { cx } from "@jugl-web/utils";

export const SignUpFlowContentLayout = ({
  title,
  subtitle,
  description,
  footer,
  hideTitleSection = false,
  titleSectionClassName = "",
}: {
  title: ReactNode;
  subtitle: ReactNode;
  description?: ReactNode;
  footer?: ReactNode;
  hideTitleSection?: boolean;
  titleSectionClassName?: string;
}) => (
  <div className="font-secondary flex w-full flex-col items-center justify-center 2xl:pr-[64px] 2xl:pt-0">
    {!hideTitleSection && (
      <div
        className={cx(
          "flex w-[400px] flex-col items-center justify-center gap-4 pb-[32px] 2xl:w-full 2xl:pb-[64px]",
          titleSectionClassName
        )}
      >
        <div className="text-dark text-center text-[32px] font-semibold">
          {title}
        </div>
        <div className="text-dark-600 text-center">{subtitle}</div>
      </div>
    )}
    <div className="flex w-full justify-center">{description}</div>
    <div className="flex flex-col items-center justify-center">{footer}</div>
  </div>
);
